import { render } from "./Number.vue?vue&type=template&id=eb5bf142&scoped=true"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"

import "./Number.vue?vue&type=style&index=0&id=eb5bf142&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5bf142"]])

export default __exports__